import { Component, ViewChild } from '@angular/core';
import { BaseModal } from '../../modals/modal-base';
import { Location } from '@angular/common';


export class AdminConsentDialogArgs {
    URL: string;
}

@Component({
    selector: 'dialog-admin-consent',
    templateUrl: './admin-consent-dialog.component.html',
    styleUrls: [
        '../../../../node_modules/bootstrap/dist/css/bootstrap.css',
        './target-validation-dialog.component.scss',
        './admin-consent-dialog.component.scss'
    ]
})
export class AdminConsentDialog extends BaseModal<AdminConsentDialogArgs> {

    private args: AdminConsentDialogArgs;
    adminConsentUrl: string = '';
    valueCopied:boolean = false;

    constructor(
        private location: Location
    ) {
        super();
    }

    onActivate(args: AdminConsentDialogArgs) {
        this.args = args;
        this.adminConsentUrl = args.URL;
    }

    onCloseClicked(e: MouseEvent) {
        e.preventDefault();
        this.closeDialog();
    }

    onClose() {}

    highlightAfterCopy(event: any) {
        this.valueCopied = !this.valueCopied;
        setTimeout(() => {
            this.valueCopied = false;
        }, 100);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/target-validation/admin-consent-dialog.component.ts